
import styled from "styled-components";
import LogsAcesso from "./LogsAcesso.js";
import LogsAlteracao from "./LogsAlteracao.js";


const Container = styled.div`
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 10px 10px;
  box-shadow: 0px 0px 2px #ccc;
  border-radius: 5px;



`;



const Grid = ({ logsAcesso, logsAlteracao }) => {


  return (


    <>
      <Container>
        <LogsAcesso logsAcesso={logsAcesso} />
        <LogsAlteracao logsAlteracao={logsAlteracao} />

      </Container>
      <style jsx global>{`
      .swal2-container.custom-swal-container {
        z-index: 9999; 
      }
    `}</style>
    </>
  );
};


export default Grid;
